// cut-gsap.js - Module version

// ============================================
// cut-3-products-grid.liquid
// ============================================
window.initProductGrid = function(sectionId) {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    setTimeout(() => window.initProductGrid(sectionId), 100);
    return;
  }
  
  const section = document.querySelector('#custom-product-grid-' + sectionId);
  if (!section) return;
  
  const productItems = section.querySelectorAll('[data-product-item]');
  const content = section.querySelector('[data-content]');
  
  // Set initial state
  gsap.set(productItems, { opacity: 0, y: 50 });
  if (content) gsap.set(content, { opacity: 0, y: 30 });
  
  // Animate products
  productItems.forEach((item, index) => {
    gsap.to(item, {
      opacity: 1,
      y: 0,
      duration: 0.6,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: section,
        start: 'top 70%',
        toggleActions: 'play none none none'
      },
      delay: index * 0.15
    });
  });
  
  // Animate content
  if (content) {
    gsap.to(content, {
      opacity: 1,
      y: 0,
      duration: 0.8,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: section,
        start: 'top 70%',
        toggleActions: 'play none none none'
      },
      delay: productItems.length * 0.15
    });
  }
};

// ============================================
// cut-cards-with-image.liquid
// ============================================
window.initCardsImage = function(sectionId) {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    setTimeout(() => window.initCardsImage(sectionId), 100);
    return;
  }

  const section = document.querySelector('#cards-image-' + sectionId);
  if (!section) return;

  gsap.registerPlugin(ScrollTrigger);

  const cards = section.querySelectorAll('.info-card');
  const sideImage = section.querySelector('.side-image');

  // Set initial state
  gsap.set(cards, { opacity: 0, x: -100 });
  if (sideImage) gsap.set(sideImage, { opacity: 0, x: 100 });

  // Animate cards
  cards.forEach((card, i) => {
    gsap.to(card, {
      opacity: 1,
      x: 0,
      duration: 0.8,
      delay: i * 0.15,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: card,
        start: 'top 80%',
        toggleActions: 'play none none reverse'
      }
    });
  });

  // Animate image
  if (sideImage) {
    gsap.to(sideImage, {
      opacity: 1,
      x: 0,
      y: 0,
      duration: 1,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: sideImage,
        start: 'top 80%',
        toggleActions: 'play none none reverse'
      }
    });
  }
};

// ============================================
// cut-grand-image-with-text.liquid
// ============================================
window.initGrandImageText = function(sectionId) {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    setTimeout(() => window.initGrandImageText(sectionId), 100);
    return;
  }
  
  const section = document.querySelector('#custom-product-split-' + sectionId);
  if (!section) return;
  
  const leftEl = section.querySelector('.custom-product-split__text--left');
  const rightEl = section.querySelector('.custom-product-split__text--right');
  if (!leftEl || !rightEl) return;
  
  // Set initial state
  gsap.set(leftEl, { opacity: 0, x: -100 });
  gsap.set(rightEl, { opacity: 0, x: 100 });
  
  // Left animation with scrub
  gsap.to(leftEl, {
    opacity: 1,
    x: 0,
    scrollTrigger: {
      trigger: section,
      start: 'top 80%',
      end: 'top 20%',
      scrub: 1.5
    }
  });
  
  // Right animation with scrub
  gsap.to(rightEl, {
    opacity: 1,
    x: 0,
    scrollTrigger: {
      trigger: section,
      start: 'top 80%',
      end: 'top 20%',
      scrub: 1.5
    }
  });
};

// ============================================
// Hero-style heading animation
// ============================================
window.animateHeroHeadings = function(selector) {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    return false;
  }

  gsap.utils.toArray(selector + ' [data-text]').forEach(heading => {
    const text = heading.dataset.text;
    const hasMask = heading.classList.contains('has-mask');
    const maskImage = heading.dataset.maskImage;
    const textColor = heading.dataset.textColor;
    
    if (!text) return;
    
    const words = text.split(' ');
    heading.innerHTML = words.map(word => {
      return `<span class="word">${word}</span>`;
    }).join(' ');
    
    const wordElements = heading.querySelectorAll('.word');
    
    // Ustaw style dla każdego słowa
    wordElements.forEach(word => {
      if (hasMask && maskImage) {
        word.style.backgroundImage = `url('${maskImage}')`;
      } else if (textColor) {
        word.style.color = textColor;
      }
    });
    
    // KLUCZOWA ZMIANA: Jawnie ustaw początkowy stan opacity
    gsap.set(wordElements, { 
      opacity: 0.2 
    });
    
    // Dostosuj parametry dla mobile i desktop
    const isMobile = window.innerWidth <= 968;
    
    gsap.to(wordElements, {
      opacity: 1,
      duration: 0.6,
      stagger: 0.4,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: heading,
        start: isMobile ? 'top 95%' : 'top 90%',
        end: isMobile ? 'top 30%' : 'bottom 60%',
        scrub: isMobile ? 0.5 : 1,
        toggleActions: 'play none none reverse',
      }
    });
  });
  
  return true;
};

// ============================================
// cut-hero-header.liquid (standalone)
// ============================================
window.initHeroHeader = function(sectionId) {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    setTimeout(() => window.initHeroHeader(sectionId), 100);
    return;
  }

  const section = document.querySelector('#hero-header-' + sectionId);
  if (!section) return;

  window.animateHeroHeadings('#hero-header-' + sectionId);
};

// ============================================
// MOBILE LOTTIE ANIMATION
// ============================================

window.initMobileLottieAnimation = function(sectionId) {

  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined' || typeof lottie === 'undefined') {
    setTimeout(() => window.initMobileLottieAnimation(sectionId), 100);
    return;
  }

  const section = document.querySelector('#home-animation-' + sectionId);
  if (!section) return;

  const isMobile = window.innerWidth <= 968;
  if (!isMobile) return;

  const lottieContainer = document.getElementById('mobile-lottie-' + sectionId);
  const lottieFixed = section.querySelector('.lottie-mobile');
  const productContentSection = section.querySelector('.product-content-section');
  const stopContainer = section.querySelector('.custom-product-grid__container');

  if (!lottieContainer || !lottieFixed) return;

  // iOS detection
  let isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
              (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  let mobileAnimation;
  let mobileFrameTween;

  function initMobileLottie() {

    if (mobileAnimation) {
      mobileAnimation.destroy();
      mobileAnimation = null;
    }

    mobileAnimation = lottie.loadAnimation({
      container: lottieContainer,
      renderer: 'canvas',
      loop: false,
      autoplay: false,
      path: 'https://cdn.shopify.com/s/files/1/0981/5185/8522/files/Cutzilla_Mobile_Opt.json?v=1771342525',
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
        clearCanvas: true,
        progressiveLoad: true,
        hideOnTransparent: true,
        devicePixelRatio: 1
      }
    });

    mobileAnimation.addEventListener('DOMLoaded', () => {
      lottieContainer.style.opacity = '1';
      setTimeout(setupMobileScrollAnimations, 100);
    });

  }

  function setupMobileScrollAnimations() {

    const totalFrames = mobileAnimation.totalFrames;

    ScrollTrigger.getAll().forEach(st => {
      if (st.vars?.id?.includes('mobile-lottie-' + sectionId)) {
        st.kill();
      }
    });

    let startPosition = 0;

    if (productContentSection) {
      const rect = productContentSection.getBoundingClientRect();
      startPosition = rect.bottom + window.scrollY + 180;
    }

    // Force hardware acceleration
    gsap.set(lottieFixed, { 
      y: startPosition,
      force3D: true,
      top: 0,
      left: 0,
      width: '100%',
      height: isIOS ? window.innerHeight + 'px' : '100vh'
    });

    const frameProxy = { frame: 0 };
    let lastRenderedFrame = -1;

    // Track all info card sections with z-index
    const infoCardsSections = document.querySelectorAll('.info-cards-section');
    if (infoCardsSections.length > 0) {
      let isAnyCardVisible = false;
      
      infoCardsSections.forEach(section => {
        ScrollTrigger.create({
          trigger: section,
          start: 'top center',
          end: 'bottom center',
          onEnter: () => {
              console.log('Section entered:', section.classList);
            if (!isAnyCardVisible) {
              isAnyCardVisible = true;
              lottieFixed.style.zIndex = '1';
            }
          },
          onLeave: () => {
            const anyVisible = Array.from(infoCardsSections).some(card => {
              const rect = card.getBoundingClientRect();
              return rect.top < window.innerHeight/2 && rect.bottom > window.innerHeight/2;
            });
            if (!anyVisible) {
              isAnyCardVisible = false;
              lottieFixed.style.zIndex = '6';
            }
          },
          onEnterBack: () => {
            if (!isAnyCardVisible) {
              isAnyCardVisible = true;
              lottieFixed.style.zIndex = '1';
            }
          },
          onLeaveBack: () => {
            const anyVisible = Array.from(infoCardsSections).some(card => {
              const rect = card.getBoundingClientRect();
              return rect.top < window.innerHeight/2 && rect.bottom > window.innerHeight/2;
            });
            if (!anyVisible) {
              isAnyCardVisible = false;
              lottieFixed.style.zIndex = '6';
            }
          }
        });
      });
    }
    // Force z-index back to 6 when hero variant 2 is visible (Chrome fix)
const heroVariant2 = document.querySelector('.hero-header-wrapper.hero-variant-2');
if (heroVariant2) {
  ScrollTrigger.create({
    trigger: heroVariant2,
    start: 'top center',
    end: 'bottom center',
    onEnter: () => {
      // Force animation above hero variant 2
      lottieFixed.style.zIndex = '6';
      console.log('Hero variant 2 entered - forcing z-index 6');
    },
    onLeave: () => {
      // Let the info cards logic take over again
      const anyInfoCardVisible = Array.from(infoCardsSections).some(card => {
        const rect = card.getBoundingClientRect();
        return rect.top < window.innerHeight/2 && rect.bottom > window.innerHeight/2;
      });
      if (!anyInfoCardVisible) {
        lottieFixed.style.zIndex = '6';
      }
    }
  });
}

    // POSITION (ENDS AT GRID CONTAINER)
    gsap.to(lottieFixed, {
      y: 0,
      ease: 'none',
      force3D: true,
      scrollTrigger: {
        id: 'mobile-lottie-position-' + sectionId,
        trigger: section,
        start: 'top bottom',
        end: () => {
          if (!stopContainer) return `top+=${startPosition}px top`;
          return "top top+=" + stopContainer.offsetTop;
        },
        scrub: true,
        invalidateOnRefresh: true
      }
    });

    // FRAME ANIMATION
    mobileFrameTween = gsap.to(frameProxy, {
      frame: totalFrames - 1,
      ease: 'none',
      scrollTrigger: {
        id: 'mobile-lottie-frames-' + sectionId,
        trigger: section,
        start: () => `top+=${startPosition}px top`,
        end: 'bottom bottom',
        scrub: true,
        invalidateOnRefresh: true
      },
      onUpdate: function() {
        let frame = Math.round(frameProxy.frame);
        frame = Math.max(0, Math.min(frame, totalFrames - 1));

        if (frame !== lastRenderedFrame) {
          mobileAnimation.goToAndStop(frame, true);
          lastRenderedFrame = frame;
        }
      }
    });

  }

  initMobileLottie();

};



// ============================================
// DESKTOP LOTTIE ANIMATION
// ============================================
window.initHomeAnimation = function(sectionId) {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    setTimeout(() => window.initHomeAnimation(sectionId), 100);
    return;
  }

  const section = document.querySelector('#home-animation-' + sectionId);
  if (!section) return;

  gsap.registerPlugin(ScrollTrigger);

  if (window.lenis) {
    window.lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add((time) => { window.lenis.raf(time * 1000); });
    gsap.ticker.lagSmoothing(0);
  }

  let animation;
  let frameTween;
  let positionTween;
  let resizeTimeout;
  let isDestroying = false;

  const lottieContainer = document.getElementById('main-lottie-' + sectionId);
  const lottieFixed = section.querySelector('.lottie-desktop');

  if (!lottieContainer || !lottieFixed) return;

  function initLottieAnimation() {
    const isMobile = window.innerWidth <= 968;
    if (isMobile) return;
    if (isDestroying) return;

    const currentFrame = animation ? animation.currentFrame : 0;
    if (animation) { animation.destroy(); animation = null; }

    try {
      animation = lottie.loadAnimation({
        container: lottieContainer,
        renderer: 'canvas',
        loop: false,
        autoplay: false,
        path: 'https://cdn.shopify.com/s/files/1/0981/5185/8522/files/Cutzilla_60fps_Opt.json?v=1771342702',
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice',
          clearCanvas: true,
          context: null,
          progressiveLoad: true,
          hideOnTransparent: true,
          devicePixelRatio: Math.min(window.devicePixelRatio || 1, 2)
        }
      });

      animation.addEventListener('DOMLoaded', () => {
        lottieContainer.style.opacity = '1';
        if (currentFrame > 0) animation.goToAndStop(currentFrame, true);
        setupScrollAnimations();
      });

      animation.addEventListener('data_failed', (error) => {
        console.error('Lottie data failed:', error);
      });

    } catch (error) {
      console.error('Error initializing Lottie:', error);
    }
  }

  function setupScrollAnimations() {
    const totalFrames = animation.totalFrames;
    const header = document.querySelector('.header__row--bottom');
    const isMobile = window.innerWidth <= 968;

    if (frameTween) frameTween.kill();
    if (positionTween) positionTween.kill();

    ScrollTrigger.getAll().forEach(st => {
      if (st.vars && st.vars.trigger === section && st.vars.id !== 'mobile-lottie-' + sectionId) {
        st.kill();
      }
    });

    if (!isMobile) {
      const setupPosition = () => {
        const headerHeight = header ? header.offsetHeight : 0;
        const sectionHeight = section.offsetHeight;
        const lottieHeight = lottieFixed.offsetHeight;
        const startY = headerHeight;
        const endY = sectionHeight - lottieHeight;

        gsap.set(lottieFixed, { y: startY, force3D: true });

        positionTween = gsap.to(lottieFixed, {
          y: endY,
          ease: 'none',
          force3D: true,
          scrollTrigger: {
            trigger: section,
            start: 'top top',
            end: 'bottom bottom',
            scrub: true,
            invalidateOnRefresh: true
          }
        });

        ScrollTrigger.refresh(true);
      };

      requestAnimationFrame(() => { setTimeout(setupPosition, 100); });
    } else {
      gsap.set(lottieFixed, { y: 0, clearProps: 'transform' });
    }

    const frameProxy = { frame: 0 };
    let lastRenderedFrame = -1;

    frameTween = gsap.to(frameProxy, {
      frame: totalFrames - 1,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top top',
        end: 'bottom bottom',
        scrub: 0.3,
        invalidateOnRefresh: true
      },
      onUpdate: function() {
        if (!animation || isDestroying) return;
        const currentFrame = Math.round(frameProxy.frame * 100) / 100;
        if (Math.abs(currentFrame - lastRenderedFrame) > 0.01) {
          try {
            animation.goToAndStop(frameProxy.frame, true);
            lastRenderedFrame = currentFrame;
          } catch (e) {
            console.warn('Frame render error:', e);
          }
        }
      }
    });
  }

  function handleResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const isMobile = window.innerWidth <= 968;

      if (!isMobile) {
        if (animation && animation.totalFrames) {
          setupScrollAnimations();
        } else {
          initLottieAnimation();
        }
      } else {
        if (animation) { animation.destroy(); animation = null; }
        if (frameTween) frameTween.kill();
        if (positionTween) positionTween.kill();
      }

      setTimeout(() => { ScrollTrigger.refresh(true); }, 100);
    }, 250);
  }

  initLottieAnimation();
  window.initMobileLottieAnimation(sectionId);
  window.addEventListener('resize', handleResize);

  window.addEventListener('beforeunload', () => {
    isDestroying = true;
    if (animation) animation.destroy();
    ScrollTrigger.getAll().forEach(st => st.kill());
  });

  // Hero Heading
  window.animateHeroHeadings('#home-animation-' + sectionId);

  // helper 
  const isMobileView = () => window.innerWidth <= 968;

  // Product Container
  const productContainer = section.querySelector('.product-container');
  if (productContainer) {
    if (isMobileView()) {
      // Na mobile — natychmiast widoczny, bez animacji wejścia
      gsap.set(productContainer, { opacity: 1, x: 0 });
    } else {
      gsap.to(productContainer, {
        opacity: 1,
        x: 0,
        duration: 1,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: productContainer,
          start: 'top 70%',
          toggleActions: 'play none none reverse'
        }
      });
    }
  }

  // Feature Items
  gsap.utils.toArray('#home-animation-' + sectionId + ' .feature-item').forEach((item, i) => {
    if (isMobileView()) {
      gsap.set(item, { opacity: 1, y: 0 });
    } else {
      gsap.to(item, {
        opacity: 1,
        y: 0,
        duration: 0.6,
        delay: i * 0.1,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: item,
          start: 'top 80%',
          toggleActions: 'play none none reverse'
        }
      });
    }
  });

  // CTA Button
  const cta = section.querySelector('.btn-wrapper');
  if (cta) {
    if (isMobileView()) {
      gsap.set(cta, { opacity: 1, y: 0 });
    } else {
      gsap.to(cta, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: cta,
          start: 'top 80%',
          toggleActions: 'play none none reverse'
        }
      });
    }
  }

  // Section Headings
  gsap.utils.toArray('#home-animation-' + sectionId + ' .section-heading').forEach(heading => {
    if (isMobileView()) {
      gsap.set(heading, { opacity: 1, x: 0 });
    } else {
      gsap.to(heading, {
        opacity: 1,
        x: 0,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: heading,
          start: 'top 75%',
          toggleActions: 'play none none reverse'
        }
      });
    }
  });

  // Info Cards
  gsap.utils.toArray('#home-animation-' + sectionId + ' .info-card').forEach(card => {
    if (isMobileView()) {
      gsap.set(card, { opacity: 1, x: 0 });
    } else {
      gsap.to(card, {
        opacity: 1,
        x: 0,
        duration: 0.8,
        delay: 0.2,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: card,
          start: 'top 75%',
          toggleActions: 'play none none reverse'
        }
      });
    }
  });
};

// ============================================
// cut-image-with-text.liquid
// ============================================
window.initImageWithText = function(sectionId) {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    setTimeout(() => window.initImageWithText(sectionId), 100);
    return;
  }

  const section = document.querySelector('#custom-split-image-' + sectionId);
  if (!section) return;

  window.animateHeroHeadings('#custom-split-image-' + sectionId);
};

// ============================================
// cut-images-3d.liquid
// ============================================
window.initImages3D = function(sectionId) {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    setTimeout(() => window.initImages3D(sectionId), 100);
    return;
  }

  const section = document.querySelector('#product-showcase-' + sectionId);
  if (!section) return;

  gsap.registerPlugin(ScrollTrigger);

  // Animate title
  const title = section.querySelector('.product-showcase-title');
  if (title) {
    gsap.to(title, {
      opacity: 1,
      y: 0,
      duration: 0.8,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: section,
        start: 'top 80%',
        toggleActions: 'play none none reverse'
      }
    });
  }

  // Animate center image
  const centerImage = section.querySelector('.showcase-image-center');
  if (centerImage) {
    gsap.to(centerImage, {
      opacity: 1,
      duration: 1,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: section.querySelector('.showcase-images-wrapper'),
        start: 'top 70%',
        toggleActions: 'play none none reverse'
      }
    });
  }

  // Animate left image
  const leftImage = section.querySelector('.showcase-image-left');
  if (leftImage) {
    gsap.to(leftImage, {
      opacity: 1,
      duration: 1,
      delay: 0.2,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: section.querySelector('.showcase-images-wrapper'),
        start: 'top 70%',
        toggleActions: 'play none none reverse'
      }
    });
  }

  // Animate right image
  const rightImage = section.querySelector('.showcase-image-right');
  if (rightImage) {
    gsap.to(rightImage, {
      opacity: 1,
      duration: 1,
      delay: 0.4,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: section.querySelector('.showcase-images-wrapper'),
        start: 'top 70%',
        toggleActions: 'play none none reverse'
      }
    });
  }
};

// ============================================
// cut-newsletter.liquid
// ============================================
window.initNewsletter = function(sectionId) {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    setTimeout(() => window.initNewsletter(sectionId), 100);
    return;
  }

  const section = document.querySelector('#newsletter-' + sectionId);
  if (!section) return;

  const container = section.querySelector('.newsletter-container');
  const logo = section.querySelector('.newsletter-logo');
  const heading = section.querySelector('.newsletter-heading');
  const description = section.querySelector('.newsletter-description');
  const form = section.querySelector('.newsletter-form');

  // Set initial states
  if (container) {
    gsap.set(container, { opacity: 0, y: 50 });
  }

  if (logo) {
    gsap.set(logo, { opacity: 0, y: -30 });
  }

  if (heading) {
    gsap.set(heading, { opacity: 0, y: 20 });
  }

  if (description) {
    gsap.set(description, { opacity: 0, y: 20 });
  }

  if (form) {
    gsap.set(form, { opacity: 0, y: 30 });
  }

  // Create timeline
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: 'top 70%',
      end: 'top 20%',
      toggleActions: 'play none none none'
    }
  });

  // Animate elements in sequence
  tl.to(container, {
    opacity: 1,
    y: 0,
    duration: 0.8,
    ease: 'power3.out'
  })
  .to(logo, {
    opacity: 1,
    y: 0,
    duration: 0.6,
    ease: 'power2.out'
  }, '-=0.4')
  .to(heading, {
    opacity: 1,
    y: 0,
    duration: 0.6,
    ease: 'power2.out'
  }, '-=0.3')
  .to(description, {
    opacity: 1,
    y: 0,
    duration: 0.6,
    ease: 'power2.out'
  }, '-=0.4')
  .to(form, {
    opacity: 1,
    y: 0,
    duration: 0.6,
    ease: 'power2.out'
  }, '-=0.4');
};

// ============================================
// cut-product-3-cards.liquid
// ============================================
window.initProduct3Cards = function(sectionId) {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    setTimeout(() => window.initProduct3Cards(sectionId), 100);
    return;
  }

  const section = document.querySelector('#product-cards-' + sectionId);
  if (!section) return;

  gsap.registerPlugin(ScrollTrigger);

  // Animate title
  const title = section.querySelector('.product-cards-title');
  if (title) {
    gsap.to(title, {
      opacity: 1,
      y: 0,
      duration: 0.8,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: section,
        start: 'top 80%',
        toggleActions: 'play none none reverse'
      }
    });
  }

  // Animate cards
  const cards = section.querySelectorAll('.product-card');
  cards.forEach((card, i) => {
    gsap.to(card, {
      opacity: 1,
      y: 0,
      duration: 0.8,
      delay: i * 0.15,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: card,
        start: 'top 85%',
        toggleActions: 'play none none reverse'
      }
    });
  });
};

// ============================================
// cut-text-section.liquid
// ============================================
window.initTextSection = function(sectionId) {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    setTimeout(() => window.initTextSection(sectionId), 100);
    return;
  }

  const section = document.querySelector('#text-block-' + sectionId);
  if (!section) return;

  gsap.registerPlugin(ScrollTrigger);

  // Animate title
  const title = section.querySelector('.text-content-title');
  if (title) {
    gsap.to(title, {
      opacity: 1,
      y: 0,
      duration: 0.8,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: section,
        start: 'top 80%',
        toggleActions: 'play none none reverse'
      }
    });
  }

  // Animate content
  const content = section.querySelector('.text-content-body');
  if (content) {
    gsap.to(content, {
      opacity: 1,
      y: 0,
      duration: 0.8,
      delay: 0.2,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: section,
        start: 'top 80%',
        toggleActions: 'play none none reverse'
      }
    });
  }
};

// ============================================
// cut-video-curved.liquid
// ============================================
window.initVideoCurved = function(sectionId) {
  const section = document.querySelector('#video-tilt-' + sectionId);
  if (!section) return;

  const isRightAligned = section.classList.contains('video-align-right');

  // Video play functionality
  const video = section.querySelector('.custom-video');
  const playButton = section.querySelector('.video-play-button');
  
  if (video && playButton) {
    playButton.addEventListener('click', function() {
      video.play().then(() => {
        playButton.classList.add('hidden');
        video.setAttribute('controls', 'controls');
      }).catch(err => {
        console.error('Error playing video:', err);
      });
    });

    video.addEventListener('play', function() {
      playButton.classList.add('hidden');
    });

    video.addEventListener('pause', function() {
      if (video.currentTime > 0) {
        playButton.classList.remove('hidden');
      }
    });
  }

  // GSAP Animation
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    setTimeout(() => window.initVideoCurved(sectionId), 100);
    return;
  }

  const wrapper = section.querySelector('.video-tilt-wrapper');
  const description = section.querySelector('.video-description');
  const textColumn = section.querySelector('.text-content-column');

  if (wrapper) {
    gsap.set(wrapper, {
      opacity: 0,
      x: isRightAligned ? 100 : -100
    });

    gsap.to(wrapper, {
      opacity: 1,
      x: 0,
      scrollTrigger: {
        trigger: section,
        start: 'top 80%',
        end: 'top 20%',
        scrub: 1.5
      }
    });
  }

  if (description) {
    gsap.set(description, {
      opacity: 0,
      y: 30
    });

    gsap.to(description, {
      opacity: 1,
      y: 0,
      scrollTrigger: {
        trigger: section,
        start: 'top 70%',
        end: 'top 30%',
        scrub: 1.5
      }
    });
  }

  if (textColumn) {
    gsap.set(textColumn, {
      opacity: 0,
      x: isRightAligned ? -100 : 100
    });

    gsap.to(textColumn, {
      opacity: 1,
      x: 0,
      scrollTrigger: {
        trigger: section,
        start: 'top 80%',
        end: 'top 20%',
        scrub: 1.5
      }
    });
  }
};

// ============================================
// cut-footer.liquid
// ============================================
window.initFooter = function(sectionId) {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    setTimeout(() => window.initFooter(sectionId), 100);
    return;
  }

  const section = document.querySelector('#footer-' + sectionId);
  if (!section) return;

  const logo = section.querySelector('.footer-logo');
  const social = section.querySelector('.footer-social');
  const columns = section.querySelectorAll('.footer-column');

  // Set initial states
  if (logo) {
    gsap.set(logo, { opacity: 0, y: 30 });
  }

  if (social) {
    gsap.set(social, { opacity: 0, y: 20 });
  }

  columns.forEach((column) => {
    gsap.set(column, { opacity: 0, y: 30 });
  });

  // Create timeline
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: 'top 85%',
      end: 'top 40%',
      toggleActions: 'play none none none'
    }
  });

  // Animate elements
  tl.to(logo, {
    opacity: 1,
    y: 0,
    duration: 0.6,
    ease: 'power2.out'
  })
  .to(social, {
    opacity: 1,
    y: 0,
    duration: 0.6,
    ease: 'power2.out'
  }, '-=0.3');

  // Animate columns with stagger
  columns.forEach((column, index) => {
    tl.to(column, {
      opacity: 1,
      y: 0,
      duration: 0.6,
      ease: 'power2.out'
    }, '-=0.4');
  });
};

// ============================================
// cut-full-width-logo.liquid
// ============================================
window.initFullWidthLogo = function(sectionId) {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    setTimeout(() => window.initFullWidthLogo(sectionId), 100);
    return;
  }

  const section = document.querySelector('#logo-section-' + sectionId);
  if (!section) return;

  gsap.registerPlugin(ScrollTrigger);

  const logo = section.querySelector('.animate-logo');
  if (logo) {
    // Set initial state
    gsap.set(logo, { opacity: 0, y: 50 });

    // Animate
    gsap.to(logo, {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: section,
        start: 'top 80%',
        toggleActions: 'play none none reverse'
      }
    });
  }
};

// ============================================
// AUTO-INIT SYSTEM
// ============================================
function initAllSections() {
  document.querySelectorAll('[data-animation]').forEach(section => {
    const type = section.dataset.animation;
    const id = section.dataset.sectionId;
    
    switch(type) {
      case 'product-grid':
        window.initProductGrid(id);
        break;
      case 'cards-image':
        window.initCardsImage(id);
        break;
      case 'grand-image-text':
        window.initGrandImageText(id);
        break;
      case 'hero-header':
        window.initHeroHeader(id);
        break;
      case 'home-animation':
        window.initHomeAnimation(id);
        break;
      case 'image-with-text':
        window.initImageWithText(id);
        break;
      case 'images-3d':
        window.initImages3D(id);
        break;
      case 'newsletter':
        window.initNewsletter(id);
        break;
      case 'product-3-cards':
        window.initProduct3Cards(id);
        break;
      case 'text-section':
        window.initTextSection(id);
        break;
      case 'video-curved':
        window.initVideoCurved(id);
        break;
      case 'footer':
        window.initFooter(id);
        break;
        case 'full-width-logo':
        window.initFullWidthLogo(id);
      break;

      default:
        console.warn('Unknown animation type:', type);
    }
  });
}

// Uruchom przy pierwszym załadowaniu
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllSections);
} else {
  initAllSections();
}

// Obsługa View Transitions (jak w Horizon)
document.addEventListener('astro:page-load', initAllSections); // Astro/View Transitions
document.addEventListener('turbo:load', initAllSections); // Turbo
document.addEventListener('turbolinks:load', initAllSections); // Turbolinks

// Shopify Theme Editor
document.addEventListener('shopify:section:load', function(event) {
  setTimeout(initAllSections, 50);
});
